import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Badge, Card, Tooltip } from "@similarweb/ui-components";
import { Flex, Stack, TruncatedText } from "@similarweb/ui-components/foundations";

import { PreviewCard } from "../../../common/preview-card/PreviewCard";
import type { SocialPostData } from "../types";

import { CreativeSection } from "./CreativeSection";
import { InfoFooter } from "./InfoFooter";

export const borderCardSize = {
    width: 360,
    height: 302,
};

const HIGH_PERFORMANCE_THRESHOLD = 66;

export type SocialPostProps = {
    post: SocialPostData;
    onClick?: () => void;
};

export const SocialPost = ({ post, onClick }: SocialPostProps) => {
    const { translate } = useTranslate();
    const { content, mediaType, assetUrl, reactions, shares, views, publishedDate, comments, svi, postUrl } = post;
    const isHighPerformance = svi > HIGH_PERFORMANCE_THRESHOLD;

    return (
        <PreviewCard
            onClick={onClick}
            style={borderCardSize}
            data-automation="social-post-card"
        >
            <Card.Header
                flexGrow={1}
                alignItems="flex-start"
            >
                <Stack
                    gap="12px"
                    paddingY="16px"
                    width="100%"
                >
                    {isHighPerformance ? (
                        <Flex inline>
                            <Tooltip
                                content={translate("activation.alerts.cards.social-post.performance-score.tooltip")}
                            >
                                <Badge
                                    type="number"
                                    data-automation="social-post-score-badge"
                                >
                                    {translate("activation.alerts.cards.social-post.performance-score.badge", {
                                        score: svi,
                                    })}
                                </Badge>
                            </Tooltip>
                        </Flex>
                    ) : null}
                    <TruncatedText
                        lineClamp={2}
                        fontVariant="body2"
                        color={colorsPalettes.carbon[400]}
                    >
                        {content}
                    </TruncatedText>
                </Stack>
            </Card.Header>
            <CreativeSection
                mediaType={mediaType}
                creativeUrl={assetUrl ?? undefined}
            />
            <InfoFooter
                type={mediaType}
                info={{
                    publishedDate,
                    reactions,
                    comments,
                    shares,
                    views,
                }}
                postUrl={postUrl ?? undefined}
            />
        </PreviewCard>
    );
};
